import React from 'react';
import { Button } from './button';
import { Col, Grid, Row } from './layout';
import { createStyles } from '@/contexts/theme-context';
import { Text, View, ViewStyle } from 'react-native';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  ctaText?: string;
  description?: string;
  icon: React.ReactNode;
  onPress?: () => void;
  style?: ViewStyle;
  title: string;
  trackingData?: TrackingData;
}
export const EmptyState: React.FC<Props> = ({
  icon,
  title,
  description,
  onPress,
  style,
  ctaText,
  trackingData,
}) => {
  const [styles] = useStyles();

  return (
    <Grid style={[styles.grid, style]}>
      <Row>
        <Col size={2} />
        <Col size={8} style={styles.content}>
          {icon}
          <View>
            <Text style={[TYPOGRAPHY.pSemiBold, styles.title]}>{title}</Text>
            {description ? (
              <Text style={[TYPOGRAPHY.p, styles.description]}>
                {description}
              </Text>
            ) : null}
          </View>
          {onPress && ctaText ? (
            <Button
              onPress={onPress}
              size="small"
              style={styles.button}
              textStyle={[TYPOGRAPHY.pSemiBold, styles.buttonTextStyle]}
              trackingData={trackingData ?? null}
              type="secondary"
            >
              {ctaText}
            </Button>
          ) : null}
        </Col>
        <Col size={2} />
      </Row>
    </Grid>
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    alignSelf: 'center',
    borderRadius: 20,
    borderWidth: 1.5,
    paddingHorizontal: 16,
  },
  buttonTextStyle: {
    fontSize: 14,
  },
  content: {
    alignItems: 'center',
    gap: 16,
    justifyContent: 'center',
  },
  description: {
    color: theme.sk.color.text.secondary,
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'center',
  },
  grid: {
    justifyContent: 'center',
    width: '100%',
  },
  title: {
    color: theme.sk.color.text.primary,
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'center',
  },
}));
